import { Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../../services/auth';
import '../../../components/layout/AppPage.css';

export type WarehouseDocumentsTab = 'pz' | 'wz';

/**
 * One sidebar item „Przyjęcia i wydania” (decision 2026-10-14) opens the PZ
 * and WZ lists as two tabs. Each list keeps its own route (`/app/pz`,
 * `/app/wz`), so every existing link and back button still lands on the
 * right tab. A role without warehouse documents sees only the WZ list, as
 * before, and therefore no tabs.
 */
export default function WarehouseDocumentsTabs({ active }: { active: WarehouseDocumentsTab }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!authService.canViewWarehouseDocuments()) return null;
  return (
    <Tabs
      className="app-page__tabs"
      activeKey={active}
      onChange={(key) => navigate(`/app/${key}`)}
      items={[
        { key: 'pz', label: t('common:menu.pzDocuments') },
        { key: 'wz', label: t('common:menu.wzDocuments') },
      ]}
    />
  );
}
